function pad(num: number, size: number) {
  const s = "000000000" + num;
  return s.substring(s.length - size);
}

export const getDateInUtc = (date: Date) => {
  return new Date(`${date.getFullYear()}-${pad(date.getMonth() + 1, 2)}-${pad(date.getDate(), 2)}T00:00:00Z`);
};
